module.exports = __webpack_public_path__ + "assets/images/project/myanmar.jpg?v=e912a583";